import { Injectable, ViewEncapsulation } from "@angular/core";
import {MatSnackBar} from '@angular/material/snack-bar';
import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
} from "@angular/core";
import { AuthService } from "src/app/auth.service";
import { BCService } from "src/app/builder/builderchecklists.service";
import {
  map,
  debounceTime,
  finalize,
  switchMap,
  tap,
  startWith,
  filter,
} from "rxjs/operators";
import { Observable, empty } from "rxjs";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  FormsModule,
} from "@angular/forms";
import { MessagerComponent } from "src/app/messager/messager/messager.component";
import { ContactsService } from "src/app/contacts/contacts.service";
import {
  faSearch,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { LoggingService } from "src/app/utils/logging.service";

@Component({
  selector: "app-mustcorrect",
  templateUrl: "./builderMustCorrect.html",
  styleUrls: ["./builderchecklists.component.css"],
})
export class BuilderMustCorrectComponent implements OnInit {
  check = {
    id: 0,
    finalnotes4builder: "",
    predrywallnotes4builder: "",
    fenlevels: "",
    insmeets: "",
    insachieve: "",
    dropped_ceiling_soffit: "",
    wall_b_shower_tub: "",
    attic_knee_walls: "",
    wall_a_porch_roof: "",
    double_walls: "",
    flr_o_unconbsmt_crawl: "",
    cantilevered_floor: "",
    r21_o_wall: "",
    slab_edge_insulation: "",
    r21_attic_platform: "",
    ins_sheathing: "",
    sip: "",
    r6_corner: "",
    ins_headr: "",
    min_wind_dr_framing: "",
    ins_wall_intersect: "",
    min_stud_spacing: "",
    duct_flue_shaft: "",
    recessed_light: "",
    sealedsillplate: "",
    topplatespresent: "",
    sealedtopplate: "",
    sealedwindows: "",
    sealedmarriagejointsmodhomes: "",
    sealed_common_wall: "",
    door_to_uncon: "",
    attic_dropdown: "",
    mode: 1,
  };

  done = false;
  street_address = "";
  id = 0;
  builderinitials = "";
  tecdate;
  checknotes: any;
  driveFolderID = "";
  engineerLetterReqd: boolean = false;
  engineerLetterError : boolean = false;

  constructor(
    public logger : LoggingService,
    public dialogRef: MatDialogRef<BuilderMustCorrectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public messager: MessagerComponent,
    private bcs: BCService
  ) {}

  ngOnInit(): void {

    if(this.data.l_tags && this.data.l_tags.includes(13)){
      this.engineerLetterReqd = true;
    }
    console.log(this.data);
    
    
    this.bcs.getCeliaForm(this.data.location_id).subscribe(
      (res) => {
        console.log(res);
        this.check = res.Form;
        this.check.mode = this.data.mode;
        this.id = res.Form.id;
      },
      (err) => {}
    );

    this.bcs.getCeliaNotes(this.data.location_id).subscribe(
      (res) => {
        this.checknotes = res.Notes[0];
        console.log(this.checknotes);
      },(err) => {}
    )

  }

 overrideEL(): void {
    this.engineerLetterReqd = false;
  }


  uploadFileToDrive(event: any) {
    const file = event.target.files[0];
    if (file) {

      const formData: FormData = new FormData();
      formData.append('file', file);

        // Append data object properties to formData
        Object.keys(this.data).forEach(key => {
          formData.append(key, this.data[key]);
        });

      this.bcs.uploadFile(this.data.folderid, formData).subscribe(
        (response) => {
          // Handle response here
          console.log('File successfully uploaded!', response);
          this.messager.openSnackBar('File successfully uploaded!', '[close]', 'successAlert');
          // write engineer letter uploaded tag to location
          this.engineerLetterReqd = false; 
          this.data.fileid = response.fileId;

          this.bcs.setEngineerLetterUploaded(this.data.location_id).subscribe(
            res => {
              this.bcs.sendEngineerLetterEmail(this.data).subscribe(res => {
                this.messager.openSnackBar('Reviewers have been notified!', '[close]', 'successAlert');
              }, err => {
                this.messager.openSnackBar('Error sending email. ', '[close]', 'errorAlert');
              });
              console.log(res);
            }, err => {
              this.engineerLetterError = true;
              this.engineerLetterReqd = false;
              console.log(err);
            })

        },
        (error) => {
          console.error('Upload error:', error);
          this.engineerLetterError = true;
          //this.engineerLetterReqd = false;
          // log the error: 
          this.messager.openSnackBar('An error occured, please contact us, [' + error.statusText + ']', '[close]', 'errorAlert');
        }
      );
    }
  }

  checkValues(value): void {
    this.check[value] = "Builder Verified";
  }

  allComplete(): boolean {
    var done = false;
    var mustCorrect = 0;
    //alertify.success("ALL COMPLETE CALLED.");
    Object.entries(this.check).forEach(function (entry) {
      if (entry[1] == "Must Correct") {
        mustCorrect = mustCorrect + 1;
      }
    });

    if (mustCorrect > 0) {
      done = false;
    } else {
      done = true;
    }
      return done;
    }

  save(f_id): void {
    let today = new Date();
    let date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();

    let locmain = {
      tec_date: date,
      builder_initials: this.builderinitials,
    };

    this.bcs.updateCeliaForm(f_id, this.check).subscribe(
      (res) => {

        this.bcs.tagCeliaForm(this.data.location_id, locmain).subscribe(
          (res) => {
            this.messager.openSnackBar(
              "Submitted successfully!",
              "[close]",
              "successAlert"
            );

            this.dialogRef.close();
          },
          (err) => {
            this.messager.openSnackBar(
              "There was an error submitting the form.",
              "[close]",
              "errorAlert"
            );
          }
        );
      },
      (err) => {} 
    );
  }
}

@Component({
  selector: "app-builderchecklists",
  templateUrl: "./builderchecklists.component.html",
  styleUrls: ["./builderchecklists.component.css"]
})
export class BuilderchecklistsComponent implements OnInit {
  customerFilter; //input from search bar
  homes; //current array of houses associated with selected builder
  isAdmin = false; //flag for determining whether admin functions are enabled.
  customerName = "Admin"; // customer name for display
  customerid; // customer id for reference
  user; //authenticated user profile object
  home$;
  customer$;
  searchtext; 
  fasearch = faSearch;
  fec = faExclamationCircle;
  panelOpenState = false;
  loadingtext: string = "";
  escertsfiltered = false; 
  perfreportFiltered = false;
  eiformFiltered = false;

  bf = new FormGroup({
    filter: new FormControl(""),
  });
  filterRe: boolean = false;
  noHomesFound: boolean = false;
  filterNR: boolean;
  isLoading: boolean = false;

  //any customers that shouldn't be able to see the view certificate button
  excludedIDs = [817];

  //customers that should see EI form
  eiFormIDs = [254, 1272];

  chips = ['Reschedule Required', 'Builder Checklist', 'EPO Hold','Performance Report', 'ES Certificate'];
  //selectedChip: string | null = null;
  selectedChips: string[] = [];

  constructor(
    public logger : LoggingService,
    private auth: AuthService,
    private bcs: BCService,
    private fb: FormBuilder,
    private contactService: ContactsService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public messager: MessagerComponent,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.customer$ = this.bf.get("filter").valueChanges.pipe(
      debounceTime(400),
      switchMap((value) =>
        value.length > 0
          ? this.contactService.getCustomersDropdown(value as string)
          : empty()
      )
    );

    this.auth.userProfile$.subscribe((profile) => {
      this.user = profile;

      this.customerid = profile
        ? profile["https://rhv2.com.metadata"].customer_id
        : 0;

      //if we have a builder logged in
      if (this.customerid > 0) {

        if (this.eiFormIDs.includes(this.customerid)) {
          this.chips.push('EI Forms');
        }

        this.bcs.getCustomerName(this.customerid).subscribe(
          (res) => {
            this.customerName = res.Customer.customer_name;
            console.log(this.customerName);
            this.isAdmin = false;
            this.bcs.init(this.customerid);
            if( !this.customerName.includes('Meritage') && !this.customerName.includes('Pulte') ){
              console.log('DOES NOT CONTAINS MERITAGE:',this.customerName);
              this.chips = this.chips.filter(chip => chip !== 'ES Certificate');
            }
          },
          (err) => {
          }
        );

        //get the homes associated with this customer
      } else {
        this.isAdmin = true;
      }

      this.bcs.loadingD$.subscribe(
        res => {
          console.log('LOADING', res);
          this.isLoading = res;
        }
      );

      this.home$ = this.bcs.getObjects().subscribe(
        (res) => {
          this.homes = res.filter( (item) => (!item.customer_jobtype.includes("Res") && !item.customer_jobtype.includes("N/S"))  ) ;
          this.homes = this.homes.map((home, index) => ({ ...home, originalIndex: index}));

                //remove chips non needed for non-meritage customers

        },
        (err) => {
        }
      );
    });
  } //ngon init


  updateToggle(event){
    this.filterRe = !this.filterRe;
    this.filterReinspectionJobs(this.filterRe);
  }

  updateNeedReviewToggle(event){
    this.filterNR = !this.filterNR;
    this.filterJobsNeedingReview(this.filterNR);
  }

  filterReinspectionJobs(filter): void {

    this.eiformFiltered = false;
    //filter this.homes for jobs that have job status of fail
    if(filter){
      this.homes = this.homes.filter((item) => item.job_status.includes("Fail"));
      this.homes = this.homes.map((home, index) => ({ ...home, originalIndex: index}));

    }else{
      this.bcs.getOriginalList().subscribe(
        (res) => {
          console.log(res);
          this.homes = res;
          this.homes = this.homes.map((home, index) => ({ ...home, originalIndex: index}));
        },
        (err) => {
        }
      );
    }
  }


  getESReport(subdivision_name, fullSubLot, home){

    let drivelink = '';
    let locfolder = false; 
    switch(this.customerid){

      case 254:
        drivelink = '1tRt6kLNALu-T4tpthGrUlqWhl38bo-5h';
        break;
      case 1522:
        drivelink = '1HoL7N26v8VPu1XUoV7M7QanKpi_e4_Uy';
        break;
      case 1272:
        drivelink = '1O33XEqx9lnsnebgPNRIAwFKzSByaW5-o';
        break;
      case 764:
        drivelink = '1ezJsMaXtiNXojHoBalP-kaeI4DiS0Fj5';
        break;
      default: 
        drivelink = home.folderid;
        locfolder = true;
        break;

      }

    
      console.log(drivelink);

    if (fullSubLot.includes("Preston Park")) {
      // Use a regular expression to remove "(letters)" or "-ES" and the following space
      fullSubLot = fullSubLot.replace(/\((\w+)\)\s*|\-ES/, '');
    }

    fullSubLot = fullSubLot.replace(/\'/g, '');
    const cleanString = function(str) {
      return str.replace(/\'/g, '')
      .replace(/\([^)]*\)/g, '') 
      .replace(/\s{2,}/g, ' ')
      .trim();
    }

    subdivision_name = cleanString(subdivision_name).replace(/\d+/g, '');
    fullSubLot = cleanString(fullSubLot)

    console.log('FULL SUB LOT:', fullSubLot);
    console.log('Subdivision Name:', subdivision_name);

    console.log(drivelink);
    //For Meritage CHA, Homes with dates beginning in 2025 are in folders separated by lots
    //Anything before 2025 will be in a _SENT folder IF it's meritage char 

    if(locfolder){
          this.bcs.getESReportLoc(false, subdivision_name, fullSubLot, drivelink).subscribe(
            (res) => {
              if(res.Files.length > 0){
                window.open(res.Files[0].webViewLink, '_blank');
                if(res.Files.length > 1){
                  window.open(res.Files[1].webViewLink, '_blank');
                }
              }else {
                this.messager.openSnackBar('No Energy Star Certificate printed for this home yet.', '', 'basicAlert');
              }
            },
            (err) => {
              this.logger.error('Error getting ES Report: ' + JSON.stringify(err));
            }
          );
    }else{

        // Meritage CLT (254): 2025+ homes live in per-subdivision subfolders; pre-2025 in _SENT
        const yearMatch = String(home.schedule_date || '').match(/\d{4}/);
        const scheduleYear = yearMatch ? parseInt(yearMatch[0], 10) : 0;
        if(scheduleYear >= 2025 || home.customer_id != 254){
          this.bcs.getESReport(false, subdivision_name, fullSubLot, drivelink).subscribe(
            (res) => {
              if(res.Files.length > 0){
                window.open(res.Files[0].webViewLink, '_blank');
              }else {
                this.messager.openSnackBar('No Energy Star Certificate printed for this home yet.', '', 'basicAlert');
              }
            },
            (err) => {
              this.logger.error('Error getting ES Report: ' + JSON.stringify(err));
            }
          );
        }else {
          this.bcs.getESReport(true, subdivision_name, fullSubLot, drivelink).subscribe(
            (res) => {
              if(res.File.length > 0){
                window.open(res.File[0].webViewLink, '_blank');
              }else {
                this.messager.openSnackBar('No Energy Star Certificate printed for this home yet.', '', 'basicAlert');
              }
            },
            (err) => {
              this.logger.error('Error getting ES Report: ' + JSON.stringify(err));
            }
          );
        } 
        }
    
  }

  getPerfReport(house){

    //console.log((house.folderid));
    console.log(house);

    
    if(house.customer_jobtype.toLowerCase().includes('performance') || house.perf_report_type.toLowerCase().includes('performance')){

      this.bcs.getPerfReport(house.folderid).subscribe(
        res => {
          console.log(res);
          if(res.Files.length > 0){
            window.open(res.Files[0].link, '_blank');
            //this.downloadFile(res.Files[0].link, res.Files[0].name);
          }else {
  
            //try the other naming convention
            this.bcs.getPerfReport2(house.folderid).subscribe(
              res => {
                console.log(res);
                if(res.Files.length > 0){
                  window.open(res.Files[0].link, '_blank');
                  //this.downloadFile(res.Files[0].link, res.Files[0].name);
                }else {
                  this.messager.openSnackBar('No Performance Report available for this home yet.', '', 'basicAlert');
                }
              },err => {
                this.messager.openSnackBar('No Performance Report available for this home yet.', '', 'basicAlert');
                //console.log(err);
              });
          }
        },err => {
          this.messager.openSnackBar('No Performance Report available for this home yet.', '', 'basicAlert');
          //console.log(err);
        })

    }else if(house.customer_jobtype.toLowerCase().includes('rescheck')){
      this.bcs.getResCheck(house.folderid).subscribe(
        res => {
          console.log(res);
          if(res.Files.length > 0){
            window.open(res.Files[0].link, '_blank');
            //this.downloadFile(res.Files[0].link, res.Files[0].name);
          }else {
            this.messager.openSnackBar('No ResCheck available for this home yet.', '', 'basicAlert');
          }
        },err => {
          this.messager.openSnackBar('No ResCheck available for this home yet.', '', 'basicAlert');
          //console.log(err);
        })
    }







  }

  filterESCerts(filter): void {

    this.eiformFiltered = false;
    this.loadingtext = filter ? "Loading Homes with Energy Certs..." : "Returning to in progress list"
    this.bcs.setLoading(true);
    this.cdr.detectChanges();

        if(filter){
          this.bcs.getEscertList().subscribe(
            res => {
              this.bcs.setLoading(false);
              this.homes = res;
              //this.homes = this.homes.map((home, index) => ({ ...home, originalIndex: index}));
            }, err => {
              this.homes = [];
            }
          );
        }else {
          this.resetFilter();
          //this.onSelectCustomer({customer_id: this.customerid, customer_name: this.customerName});
        }    
  }

  filterPerfReports(filter): void {

    this.eiformFiltered = false;
    this.loadingtext = filter ? "Loading Homes with Performance Reports..." : "Returning to in progress list"
    this.bcs.setLoading(true);
    this.cdr.detectChanges();

        if(filter){
          this.perfreportFiltered = true;
          this.bcs.getPerfReportList().subscribe(
            res => {
              this.bcs.setLoading(false);
              this.homes = res;
            }, err => {
              this.homes = [];
            }
          );
        }else {
          this.perfreportFiltered = false;
          this.resetFilter();
          //this.onSelectCustomer({customer_id: this.customerid, customer_name: this.customerName});
        }    
  }

  filterEIForms(filter): void {

    this.loadingtext = filter ? "Loading EI Form data..." : "Returning to in progress list"
    this.bcs.setLoading(true);
    this.cdr.detectChanges();

        if(filter){
          this.eiformFiltered = true;
          this.bcs.getEIFormList().subscribe(
            res => {
              this.bcs.setLoading(false);
              this.homes = res;
            }, err => {
              this.homes = [];
            }
          );
        }else {
          this.eiformFiltered = false;
          this.resetFilter();
        }    
  }



  

  downloadFile(url: string, filename: string) {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }
  

  toggleSelection(chip: string) {

      //if the chip is not "Performance Report" reset the filter
      if(chip !== "Performance Report"){
        this.perfreportFiltered = false;
      }

      const index = this.selectedChips.indexOf(chip);
      if (index >= 0) {
        // Remove the chip if it's already selected
        this.selectedChips.splice(index, 1);
        this.filterOnFunction(chip, false);
      } else {

        // Reset selected chips, and push the new chip. 
        this.selectedChips = [];
        this.selectedChips.push(chip);
        //update the filter condition: 
        this.filterOnFunction(chip, true);
      }
  


  }



  filterOnFunction(chip, filter: boolean){
    switch(chip){
      case 'Reschedule Required':
        this.filterReinspectionJobs(filter);
        break;
      case 'Builder Checklist':
        this.filterJobsNeedingReview(filter);
        break;
      case 'Performance Report':
        this.filterPerfReports(filter);
        break;
      case 'ES Certificate':
        this.filterESCerts(filter);
        break;
      case 'EPO Hold':
        this.filterEPOHold(filter);
        break;
      case 'EI Forms':
        this.filterEIForms(filter);
        break;
      default:
        console.log('No filter found for: ', chip);
        break;
    }
  }

  isSelected(chip: string): boolean {
    return this.selectedChips.includes(chip);
  }

  filterJobsNeedingReview(filter): void {

    
    this.eiformFiltered = false;
    if (filter) {
      this.bcs.getOriginalList().subscribe(
        res => {
          console.log(res)
          this.homes = res;

          this.homes = this.homes.filter((item) => {
            // Check if job needs review based on the criteria provided
            return (
              // Condition 1: builder_done is true or null, AND pdwdone is true
              ((item.builder_done || item.builder_done === null) && item.pdwdone) ||
              // Condition 2: builder_done is explicitly false, AND pdwdone is true, AND builder_done is not null
              (!item.builder_done && item.pdwdone && item.builder_done !== null)
            );

        },err => {
          console.log(err);
        });

      });
      // Map homes to include originalIndex
      this.homes = this.homes.map((home, index) => ({ ...home, originalIndex: index}));
    } else {
      this.bcs.getOriginalList().subscribe(
        (res) => {
          console.log(res);
          this.homes = res;
          this.homes = this.homes.map((home, index) => ({ ...home, originalIndex: index}));
        },
        (err) => {
          // Handle error here
        }
      );

    }
  }

  filterEPOHold(filter): void {
      this.eiformFiltered = false;
      if (filter) {
        this.bcs.getOriginalList().subscribe(
          res => {
            console.log(res)
            this.homes = res;
  
            this.homes = this.homes.filter((item) => {
              // Check if job needs review based on the criteria provided
              return (
                // Condition 1: builder_done is true or null, AND pdwdone is true
                (item.job_status.toLowerCase().includes('epo'))
              );
  
          },err => {
            console.log(err);
          });
        });
        // Map homes to include originalIndex
        this.homes = this.homes.map((home, index) => ({ ...home, originalIndex: index}));
      } else {
        this.bcs.getOriginalList().subscribe(
          (res) => {
            console.log(res);
            this.homes = res;
            this.homes = this.homes.map((home, index) => ({ ...home, originalIndex: index}));
          },
          (err) => {
            // Handle error here
          }
        );
  
      }
  }

  mustCorrectOpen(l_id, index, ogindex): void {

    let fwidth = '';
    let fheight = '';
    let mediaWidth = window.matchMedia('(min-width: 540px)');

    if (mediaWidth.matches) {
      //set the width manually
      fwidth = '575px;';
      fheight = '700px;';
    } else {
      fwidth = '100vw';
      fheight = '100vh';
    }
    const selectedHome = this.homes.find(home => home.originalIndex === ogindex);
    if (selectedHome) {
      const dialogRef = this.dialog.open(BuilderMustCorrectComponent, {
        width: fwidth,
        height: fheight,
        data: {
          location_id: l_id,
          folderid: selectedHome.folderid,
          subdivision_name: selectedHome.subdivision_name,
          lot: selectedHome.lot,
          street_address: selectedHome.street_address,
          l_tags: selectedHome.l_tags,
          mode: 1,
          fileid: ''
        },
        panelClass: "edit-dialog-container",
      });

      dialogRef.afterClosed().subscribe((result) => {
  
        if (result == 4) {
          const indexToRemove = this.homes.findIndex(home => home.originalIndex === ogindex);
        
          if (indexToRemove > -1) { // Ensure the home was found
            this.homes.splice(indexToRemove, 1);
          } else {
            console.error('No home found with originalIndex:', ogindex);
          }
        }
      });

    } else {
      console.error('Error opening checklist, please refresh. ', ogindex);
    }



    //
  }

  progress(house) {
    let styles = {
      "background-color": "white",
      top: "0; bottom: 0",
      left: "0",
      transition: "all 3s",
      "-webkit-transition": "all 3s",
      animation: "2s ease-out 0s 1 slideInLeft",
      height: "100%",
      "background-size": "100% 100%",
      width: "100%",
    };

    if (house.job_status.toLowerCase().includes("fail")) {
      styles["background-color"] = "rgba(250,0,0,0.1)";
      return styles;
    } else if (house.job_status.toLowerCase().includes("pass")) {
      styles["background-color"] = "rgba(0,255,0,0.3)";
      return styles;
    } else {
      return styles;
    }
  }

  rowClass(house): string {
    if (house.job_status.toLowerCase().includes("fail")) {
      //return 'back-red';
      return "background-color: rgba(250,0,0,0.1)";
    } else if (house.job_status.toLowerCase().includes("pass")) {
      //return 'back-green';
      return "background-color: rgba(0,255,0,0.3)";
    } else {
      //return 'back-normal';
      return "background-color: #ffffff";
    }
  }

  setChips(): void {

    this.chips = ['Reschedule Required', 'Builder Checklist', 'EPO Hold', 'Performance Report', 'ES Certificate'];
    if (!this.customerName.includes("Meritage") && !this.customerName.includes("Pulte") ) {
      this.chips = this.chips.filter((chip) => chip !== "ES Certificate");
    }
  }

  showExclamation(home): boolean {
    if (home.job_status.toLowerCase().includes("fail")) {
      return false;
    } else {
      return true;
    }
  }

  resetFilter(): void {
    //console.log('RESETTING');
    this.perfreportFiltered = false;
    this.eiformFiltered = false;

    this.loadingtext = "Resetting..."
    this.bcs.setLoading(true);
    this.bcs.getOriginalList().subscribe( 
      res => {
        this.homes = res;
        this.homes = this.homes.map((home, index) => ({ ...home, originalIndex: index}));
        this.bcs.setLoading(false);
      }, err => {
        //
      }); 

    this.selectedChips = [];
    this.escertsfiltered = false;
  }

  onSelectCustomer(customer, loadingText:string = "Loading Homes..."): void {

    this.bcs.init(customer.customer_id);
    this.resetFilter();
    this.loadingtext = loadingText;
    this.cdr.detectChanges();
    this.bcs.setLoading(true);

    this.bf.get("filter").setValue(customer.customer_name);
    this.customerid = customer.customer_id;
    this.customerName = customer.customer_name;
    console.log(this.customerid);
    
    this.setChips();
    console.log(this.chips);


    if (this.eiFormIDs.includes(this.customerid)) {
      this.chips.push('EI Forms');
    }

    this.bcs.getCustomerHomes(customer.customer_id).subscribe(
      (res) => {
        this.bcs.setObjects(res.List);
        this.bcs.setOriginalList(res.List);

        console.log(res);
        this.bcs.setLoading(false);
        if(res.Rows == 0){
          console.log('No ROWS');
          this.noHomesFound = true;
        }else{
          this.noHomesFound = false;
        }
      },
      (err) => {
      }
    );
  }

  mustCorrectOpenEmbed(): void {}
}
